import { z } from "zod";

export const ServiceProductItemSchema = z.object({
  Id: z.string().uuid(),
  Duration: z.number().optional(),
  Name: z.string().optional(),
  ProductId: z.string().uuid().optional(),
  ProductName: z.string().optional(),
  ServiceTypeId: z.string().uuid().optional(),
});

export type ServiceProductItemType = z.infer<typeof ServiceProductItemSchema>;

export const ServiceProductState = {
  ACTIVE: 0,
  INACTIVE: 1,
} as const;
